module.exports = __webpack_public_path__ + "static/img/logo.11d2dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/lgct/logo.png
// module id = zWYb
// module chunks = 23